import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface HistorialEntry {
  timestamp: string;
  updatedBy: string;
  incidentStatus?: string;
}

export interface DialogHistorialData {
  incidentType: 'REVISION_AC' | 'INCIDENCIA_PRE_OPERATIVA';
  historial: HistorialEntry[];
}

@Component({
  selector: 'app-dialog-incident-history',
  templateUrl: './dialog-incident-history.component.html',
  styleUrls: ['./dialog-incident-history.component.css']
})
export class DialogIncidentHistoryComponent implements OnInit {
  sortedHistorial: HistorialEntry[] = [];

  constructor(
    public dialogRef: MatDialogRef<DialogIncidentHistoryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogHistorialData
  ) {}

  ngOnInit(): void {
    if (this.data && this.data.historial) {
      this.sortedHistorial = [...this.data.historial].sort(
        (a, b) =>
          new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime()
      );
    }
  }

  close(): void {
    this.dialogRef.close();
  }

  formatDate(isoString: string): string {
    const date = new Date(isoString);
    const months = [
      'Enero',
      'Febrero',
      'Marzo',
      'Abril',
      'Mayo',
      'Junio',
      'Julio',
      'Agosto',
      'Septiembre',
      'Octubre',
      'Noviembre',
      'Diciembre'
    ];
    const month = months[date.getMonth()];
    const day = date.getDate();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${month} ${day} - ${hours}:${minutes}`;
  }

  get hasSistemaMigration(): boolean {
    return this.sortedHistorial.some(
      (item) => !!item.updatedBy && item.updatedBy.includes('Sistema')
    );
  }
}
